import {NgModule} from '@angular/core';
import {SharedModule} from '../../../core/shared.module';
import {UIRouterModule} from '@uirouter/angular';
import {WorkflowPipesModule} from '../pipes/workflow-pipes.module';
import {FETCH_STATES} from './fetch.states';
import {FetchListComponent} from './fetch-list.component';
import {WorkflowNavigationModule} from '../navigation/workflow-navigation.module';
import {FetchCamListComponent} from './fetch-cam-list.component';
import {FetchCamArticleStateComponent} from './fetch-cam-article-state.component';
import {
  FetchArticleUsageStateLabelComponent
} from './article-usage-state/fetch-article-usage-state-label.component';
import {
  FetchArticleUsageStateDropdownComponent
} from './article-usage-state/fetch-article-usage-state-dropdown.component';
import {EvStatusLabelComponent} from '../../../common/ev-status-label/ev-status-label.component';

@NgModule({
    imports: [
        SharedModule,
        UIRouterModule.forChild({ states: FETCH_STATES }),
        WorkflowPipesModule,
        WorkflowNavigationModule,
        EvStatusLabelComponent,
    ],
    exports: [
        FetchArticleUsageStateLabelComponent,
        FetchArticleUsageStateDropdownComponent,
    ],
    declarations: [
        FetchListComponent,
        FetchCamListComponent,
        FetchCamArticleStateComponent,
        FetchArticleUsageStateLabelComponent,
        FetchArticleUsageStateDropdownComponent,
    ]
})
export class FetchModule {
}
